module.exports = __webpack_public_path__ + "img/图片18.ef3295ad.png";